import { render } from "./PreCommentaryPage.vue?vue&type=template&id=67a773b2&scoped=true&ts=true"
import script from "./PreCommentaryPage.vue?vue&type=script&lang=ts"
export * from "./PreCommentaryPage.vue?vue&type=script&lang=ts"

import "./PreCommentaryPage.vue?vue&type=style&index=0&id=67a773b2&lang=postcss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a773b2"]])

export default __exports__